import React from 'react';
import './EnvironmentalClearance.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import environment_dummy_1 from '../../assets/images/environmrnt-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_environment_banner from '../../assets/images/img_peso1_banner.png';
import { FaLeaf, FaFileAlt, FaBalanceScale, FaCogs, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function EnvironmentalClearance() {
  const environmentBenefits = [
    {
      icon: <FaLeaf />,
      title: 'Environmental Sustainability',
      text: 'Promote sustainable practices and minimize environmental impact.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Regulatory Compliance',
      text: 'Meet legal obligations under environmental laws.',
    },
    {
      icon: <FaBalanceScale />,
      title: 'Risk Management',
      text: 'Avoid legal and financial risks associated with non-compliance.',
    },
    {
      icon: <FaCogs />,
      title: 'Project Continuity',
      text: 'Ensure uninterrupted progress by adhering to regulations.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Understand your project and its environmental implications.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Preparation',
      description: 'Prepare all required documents and assessments.',
    },
    {
      icon: <FaLeaf />,
      title: 'Impact Assessment',
      description: 'Conduct environmental impact studies and evaluations.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the application to the appropriate authority.',
    },
    {
      icon: <FaCertificate />,
      title: 'Approval Issuance',
      description: 'Receive environmental clearance to move forward with your project.',
    },
  ];

  const acts = [
    "Environmental Protection Act, 1986",
    "Air (Prevention and Control of Pollution) Act, 1981",
    "Water (Prevention and Control of Pollution) Act, 1974",
    "EIA Notification, 2006"
  ];

  const explanation = "These laws and regulations aim to ensure environmental protection and sustainable development while enabling projects to proceed responsibly.";

  const checklistItems = [
    { name: 'Project Report', description: 'Provide a detailed report outlining the scope of the project.' },
    { name: 'Environmental Impact Assessment (EIA)', description: 'Submit a comprehensive EIA report.' },
    { name: 'Consent from Pollution Control Board', description: 'Obtain the necessary permissions from the pollution control board.' },
    { name: 'Affidavit of Compliance', description: 'Submit an affidavit ensuring compliance with environmental regulations.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Environmental Clearance Services"
        subheading="Simplify the process of obtaining environmental clearance for your projects."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/environmental-clearance" }}
        backgroundImage={environment_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Environmental Clearance?"
        description="Environmental clearance is mandatory for projects with potential environmental impact. We assist you in navigating the approval process seamlessly."
        image={img_environment_banner}
        altText="Environmental Clearance Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Environmental Clearance"
        description="Discover how environmental clearance ensures legal compliance and sustainable project development."
        benefits={environmentBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Environmental Laws and Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Environmental Clearance Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Environmental Clearance Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
